<section class="products-user-zone" id="products-user-zone">
    
    <app-header class="offers--active products--active shopping--active"></app-header>

    <div class="page">
        <div class="space-header"></div>
        <div class="tabs-products">
            <mat-tab-group animationDuration="0ms" [(selectedIndex)]="currentTab" (selectedTabChange)="onTabChange($event);">
                <mat-tab>
                    <ng-template mat-tab-label>
                        <mat-icon class="icon-publicaciones mr-small"></mat-icon>
                        Publicaciones
                    </ng-template>

                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <mat-icon class="icon-productos mr-base"></mat-icon> Productos
                    </ng-template>
                    <app-my-products class="bg-my-data" [userType]="userType"></app-my-products>                    
                </mat-tab>

                <mat-tab>
                    <ng-template mat-tab-label>
                        <mat-icon class="icon-subasta mr-small"></mat-icon>
                        <p>Ofertas <br> realizadas</p>
                    </ng-template>
                </mat-tab>
                <mat-tab >

                    <ng-template mat-tab-label>
                        <mat-icon class="icon-ofertas mr-small"></mat-icon>
                        <p>Ofertas <br> recibidas</p>
                    </ng-template>
  
                </mat-tab>  

            </mat-tab-group>
        </div>
    </div>
    <lib-cc-footer [ccEnvironment]="ccEnvironment"></lib-cc-footer>
</section>